import { render, staticRenderFns } from "./ChaptersList.vue?vue&type=template&id=2df84d28&"
import script from "./ChaptersList.vue?vue&type=script&lang=js&"
export * from "./ChaptersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports